<template>
<div class="cita w-100">

  <v-toolbar flat class="sub-toolbar">
      <!-- Esc salir -->
      <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' v-show="showEventCreationDialog2" @click='showEventCreationDialog2 = false'>
      <label class='txt-footer-izq' v-show="showEventCreationDialog2">{{ $t('lang.comun.salir') }}</label>-->
      <v-btn flat class="primary-color" @click.stop="dialogHorario = true"><v-icon class="mr-2">schedule</v-icon> Horario tienda</v-btn>
      <!-- Añadir cita -->
      <v-btn  v-if="permitido('MOBILESTORE.GESTIONTIENDA.CITAPREVIA.CRUD')"  @click='(showEventCreationDialog2) ? crearCita() : showEventCreationDialog2=true'
          flat
          text
          class="primary-color rounded-0 my-0">
       <!-- <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif'>-->
       <v-icon class="mr-2">edit_calendar</v-icon>Añadir cita<!--v-if="!showEventCreationDialog2"-->
        <!--<span  v-else><v-icon class="mr-1">event_available</v-icon>Guardar cita</span>-->
      </v-btn>
   </v-toolbar>

  <vue-cal :selected-date="selectedDate"
        locale="es"
        class="vuecal--blue-theme vuecal--full-height-delete mx-3 margin-top"
        active-view="week"
        :disable-views="['years', 'year']"
        events-on-month-view="short"
        :time-from="horaApertura * 60" :time-to="horaCierre * 60"
        :time-step="30"
        :editable-events="{ title: false, drag: false, resize: false, delete: true, create: false }"
        ref="vuecal"
        today-button
        :events="events"
        :on-event-click="onEventClick"
        @event-delete="borrarCita"
        @cell-focus="cambiarFecha"
        >
      <template v-slot:today-button>
        <!-- Using Vuetify -->
        <v-tooltip>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" flat class="primary">
              HOY
            </v-btn>
          </template>
        </v-tooltip>
    </template>
    <template v-slot:arrow-prev>
      <button type="button" @click="mesAtras()" aria-label="Previous month" class="vuecal__arrow vuecal__arrow--prev"><i class="angle"></i></button>
    </template>
    <template v-slot:arrow-next>
      <button type="button" @click="mesAdelante()" aria-label="Previous month" class="vuecal__arrow vuecal__arrow--next ml-0"><i class="angle"></i></button>
    </template>
  </vue-cal>
   <!-- modal -->
  <transition name="modal">
    <!-- <div class="modal-mask" v-if="showEventCreationDialog" >
      <div class="modal-wrapper">
        <v-card style="width:400px; margin:0 auto;">
          <v-card-title>
            <v-text-field v-model="selectedEvent.title" placeholder="Nombre"/>
          </v-card-title>
          <v-card-title>
             <v-text-field v-model="selectedEvent.start"/>
          </v-card-title>
          <v-card-title>
            <v-text-field v-model="selectedEvent.end"/>
          </v-card-title> 
          <v-card-title>
            <v-text-field v-model="selectedEvent.content" placeholder="Teléfono"/>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="selectedEvent.contentFull" placeholder="Descripción"/>
            <v-layout>
              <v-select
                :items="eventsCssClasses"
                placeholder="Color"
                @change="selectedEvent.class = $event"
                :value="selectedEvent.class"/>
              <v-switch v-model="selectedEvent.background" label="background Event"/>
            </v-layout>
            <v-layout>
              <v-btn @click="cancelEventCreation()">{{ $t('lang.comun.cancelar') }}</v-btn>
              <v-btn @click="closeCreationDialog()">{{ $t('lang.comun.guardar') }}</v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </div> -->
   <div v-if="showEventCreationDialog" >
      <div @click="showEventCreationDialog=false">
        <v-card v-model="dialog2" class="search cita-content ">
               <v-toolbar flat class="d-flex justify-space-between">
                  <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">event</v-icon>
                  {{ selectedEvent.title }}</v-toolbar-title>
                  <v-btn @click='showEventCreationDialog2 = false'
                    icon
                    flat
                    class="primary-color">
                  <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
                  <!--{{ $t('lang.comun.salir') }}-->
                  <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar> 
              <!-- <v-icon>{{ selectedEvent.icon }}</v-icon> -->
              <v-spacer/>
              <div >
                <h4 class="px-4 mb-0">{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }}</h4>
                <p class="px-4 h6 my-0">{{ selectedEvent.start && selectedEvent.start.format('HH:mm') }} - {{ selectedEvent.start && selectedEvent.end.format('HH:mm') }}</p>
              </div>
            <v-card-text>
              <p class="text-uppercase h2 px-4" v-html="selectedEvent.contentFull"/>
              <p class="px-4 h6 my-0">Detalle</p>
              <ul>
                <li>Teléfono {{ selectedEvent.content }}</li>
                <li>Email {{ selectedEvent.email }}</li>
              </ul>
            </v-card-text>
        </v-card>
      </div>
    </div>
      <!--<div v-if="showEventCreationDialog" >
        <v-dialog class="cita-content" v-model="showEventCreationDialog" >
               <v-toolbar flat class="d-flex justify-space-between">
                  <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">edit_calendar</v-icon>edit_calendar</v-toolbar-title>
                  <v-btn @click="showEventCreationDialog=false"
                      icon
                      flat
                      class="primary-color">
                    img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
                    <!--{{ $t('lang.comun.salir') }}
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar> -->
              <!-- <v-icon>{{ selectedEvent.icon }}</v-icon> 
              <span>{{ selectedEvent.title }}</span>
              <v-spacer/>
              <div class="text-right">
                <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }}</strong>
                <strong>{{ selectedEvent.start && selectedEvent.start.format('HH:mm') }} - {{ selectedEvent.start && selectedEvent.end.format('HH:mm') }}</strong>
              </div>
         
            <v-card-text>
              <p v-html="selectedEvent.contentFull"/>
              <strong>Detalle</strong>
              <ul>
                <li>Teléfono {{ selectedEvent.content }}</li>
                <li>Email {{ selectedEvent.email }}</li>
              </ul>
            </v-card-text>
        </v-dialog>
      </div>-->
    

  </transition>
  <transition >
   <div v-if="showEventCreationDialog2" >
      <!--  <div class="modal-wrapper"> -->
      <div class="horario" v-if="showEventCreationDialog2">
        <v-dialog v-model="dialog" >
          <v-card id="search" class="anadir-cita">
          <v-toolbar flat class="d-flex justify-space-between">
            <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">edit_calendar</v-icon>Añadir cita</v-toolbar-title>
            <v-btn @click='showEventCreationDialog2 = false'
              icon
              flat
              class="primary-color">
            <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
            <!--{{ $t('lang.comun.salir') }}-->
            <v-icon>close</v-icon>
          </v-btn>
          </v-toolbar> 
        <div class="px-5 pt-2 pb-5 d-flex flex-wrap">
          <v-col>
            <v-text-field v-model="cita.title" label="Nombre"/>
          </v-col>
          <v-col>
            <v-text-field v-model="cita.email" label="Email"/>
          </v-col>
          <v-col>
            <v-text-field v-model="cita.telefono" label="Teléfono"/>
          </v-col>
          <v-col>
             <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="cita.dia"
                    label="Fecha"
                    readonly
                    append-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker locale="es" v-model="cita.dia" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
              <!--<BFormInput type="time" v-model="cita.horaini"></BFormInput>-->
          </v-col>
          <v-col>
            <!--<v-select
                :items="[rangoMinutos*1,rangoMinutos*2,rangoMinutos*3,rangoMinutos*4]"
                placeholder="Minutos"
                v-model="cita.minutos">
                <template slot="selection" slot-scope="data">
                  {{ data.item }} minutos
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item }} minutos
                </template>
            </v-select>-->
             <v-menu
                ref="menu"
                v-model="menuhour"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="cita.horaini"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="cita.horaini"
                    label="Hora"
                    append-icon="schedule"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menuhour"
                  v-model="cita.horaini"
                  full-width
                  @click:minute="$refs.menu.save(cita.horaini)"
                ></v-time-picker>
              </v-menu>
          </v-col>
           <v-col>
              <v-select
                :items="eventsCssClasses"
                label="Color"
                v-model="cita.class">
                <template slot="selection" slot-scope="data" >
                  <div :class="['vuecal__event', data.item ]" class=" d-flex" > {{ data.item }} </div>
                </template>
                <template slot="item" slot-scope="data" >
                  <div :class="['vuecal__event', data.item ]" > {{ data.item }}</div>
                </template>
              </v-select>
              <!-- <v-switch v-model="selectedEvent.background" label="background Event"/> -->
          </v-col>
          <v-col class="w-100">
            <v-textarea outlined v-model="cita.desc" label="Descripción" >
            </v-textarea>
          </v-col>
         
          </div>
            <v-btn  v-if="permitido('MOBILESTORE.GESTIONTIENDA.CITAPREVIA.CRUD')"  @click='crearCita() '
                large
                fab
                dark
                absolute
                bottom
                right
                class="orange guardar">
            <!-- <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif'>-->
              <v-icon>save</v-icon>
            </v-btn>
          </v-card>
        </v-dialog>
      </div>
      <!-- </div> -->
    </div>
  </transition>
  <!-- Modal horario -->
  <v-dialog v-model="dialogHorario">
    <div  id="search" >
      <v-toolbar flat class="d-flex justify-space-between">
      <v-toolbar-title class="primary-color text-uppercase"><v-icon class="mr-2 primary-color ">schedule</v-icon>Horario tienda</v-toolbar-title>
      <v-btn
        icon
        flat
        class="primary-color"
        @click="dialogHorario = false">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
        <horario-tienda ></horario-tienda>
    </div>
  </v-dialog>
  <!--  -->
  <!-- Footer de botones 
    <div id='footer'>-->
      <!-- Esc salir 
      <img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' v-show="showEventCreationDialog2" @click='showEventCreationDialog2 = false'>
      <label class='txt-footer-izq' v-show="showEventCreationDialog2">{{ $t('lang.comun.salir') }}</label>-->
      <!-- Añadir cita 
      <div class="d-inline" v-if="permitido('MOBILESTORE.GESTIONTIENDA.CITAPREVIA.CRUD')">
        <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' @click='(showEventCreationDialog2) ? crearCita() : showEventCreationDialog2=true'>
        <label class='txt-footer-der' v-if="!showEventCreationDialog2">Añadir cita</label>
        <label class='txt-footer-der' v-else>Guardar cita</label>
      </div>
    </div>-->
    <!-- FIN. Footer de botones -->
  <!-- <div class="botonera">
    <button type="button" class="ds-add-event-today v-btn v-btn--active v-btn--bottom v-btn--floating v-btn--right primary" @click="showEventCreationDialog2=true">
      <div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">add</i></div>
    </button>
    <button type="button" class="ds-add-event-today v-btn v-btn--active v-btn--bottom v-btn--floating v-btn--right primary" @click="showEventCreationDialog3=true">
      <div class="v-btn__content"><img  class='btn-generico' style="width:30px;"
                  :src='require("@/assets/images/reloj.png")'
                  :alt="$t('lang.comun.anterior')"/></div>
    </button>
  </div> -->
  <!-- fin modal -->
  <!--Modal Horario-->
   <!-- <div class="modal-mask" v-show="showEventCreationDialog3" >
      <div class="modal-wrapper" >
        <v-card style="width:500px; margin:0 auto;">
          <horario-tienda v-on:cerrar="showEventCreationDialog3 = false" v-on:cambiarHorario="cambiarHorario(arguments)"></horario-tienda>
        </v-card>
      </div>
   </div> -->
  <!-- fin modal -->
</div>
</template>

<script>
import { CitaApiService } from '@/api/CitaApiService'
import { Util } from '@/api/Util'

import HorarioTienda from '@/views/HorarioTienda'

const citaApiService = new CitaApiService()
const util = new Util()
const moment = require("moment")

export default {
  data () {
    return {
      dialog2:true,
      dialog:true,
      dialogHorario: false,
      opuid: this.$store.getters.getOpuid,
      selectedEvent: {},
      selectedDate : new Date().toJSON().slice(0,10),
      showEventCreationDialog: false,
      showEventCreationDialog2: false,
      showEventCreationDialog3: false,
      menu2: false,
      menuhour: false,
      eventsCssClasses: ['azul', 'rosa', 'salmon','verde'],
      horaApertura: 9,
      horaCierre: 22,
      rangoMinutos: 15,
      cita:{
        title:'',
        telefono: '',
        desc: '',
        minutos: 15,
        dia: new Date().toJSON().slice(0,10),
        horaini:'09:00',
        email: '',
        class: ''
      },
      events: [
        //eventos de ejemplo
          // {
          //   start: '2020-05-20 14:00',
          //   end: '2020-05-20 18:00',
          //   title: 'Fran',
          //   icon: 'phone', // Custom attribute.
          //   content: '665220320',
          //   contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', // Custom attribute.
          //   class: 'azul'
          // },
          // {
          //   start: '2020-05-20 14:00',
          //   end: '2020-05-20 18:00',
          //   title: 'John',
          //   icon: '', // Custom attribute.
          //   content: '945230220',
          //   contentFull: 'Okay.<br>It will be a 18 hole golf course.', // Custom attribute.
          //   class: 'salmon'
          // }
        ]
    }
  },
  components: {
    'horario-tienda': HorarioTienda
  },
  created () {
    this.mountListenerTeclas()
    this.cambioTitulo()
    this.init()
  },
  watch: {
    cambiotienda (value) {
      this.opuid = value;
      this.init()
    },
		cliente(value) {
			if (value !== null) {
				this.cita.email = value.email
        this.cita.title = value.nombre
        this.cita.telefono = value.movil === '' ? value.telefonoUno ==='' ? value.telefonoDos : value.telefonoUno : value.movil
			} else {
				this.cita.email = ''
        this.cita.title = ''
        this.cita.telefono = ''
			}
		}
  },
  methods: {
    init () {
      if (this.cliente !== null) {
				this.cita.email = this.cliente.email
        this.cita.title = this.cliente.nombre
        this.cita.telefono = this.cliente.movil === '' ? this.cliente.telefonoUno ==='' ? this.cliente.telefonoDos : this.cliente.telefonoUno : this.cliente.movil
      }
      this.getAllCitapreviaByOpuid()
    },
    mesAtras() {
    },
    mesAdelante() {
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">schedule</v-icon>`
      this.$store.state.titulo = "Cita previa"
    },
    mountListenerTeclas () {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) { // ESC
          this.showEventCreationDialog2 = false
        } else if (e.keyCode === 35) { // FIN
          if (this.showEventCreationDialog2) {
            this.crearCita()
          } else {
            this.showEventCreationDialog2 = true
          }
        } 
      })
    },
    getAllCitapreviaByOpuid() {
      while (this.events.length)
          this.events.pop()
      //this.$refs.vuecal.$forceUpdate
      if (this.opuid) {
        citaApiService.getAllCitapreviaByOpuid(this.opuid)
          .then(data => {
            if (data) {
              data.forEach(element => {
                let horainiAux, horafinAux
                if (element.mscp_horaini) {
                  horainiAux = element.mscp_horaini
                } else {
                  horainiAux = '09:00'
                }
                if (element.mscp_horafin) {
                  horafinAux = element.mscp_horafin
                } else {
                  horafinAux = '17:00'
                }
                let eventAux = {
                  id: element.mscp_id,
                  title: element.mscp_nombre,
                  content: element.mscp_telefono,
                  email: element.mscp_email,
                  start: element.mscp_fecha + ' ' + horainiAux,
                  end: element.mscp_fecha + ' ' + horafinAux,
                  class: element.mscp_color,
                  contentFull: element.mscp_desc
                }
                this.events.push(eventAux)
              })
            }
            else {   
             util.mostrarEnConsola('citaApiService - getAllCitapreviaByOpuid', data.length, 'No hay registros')
            }
            util.mostrarEnConsola('citaApiService - getAllCitapreviaByOpuid', data.length, 'OK')
            
          })
          .catch(error => {
            util.mostrarEnConsola('citaApiService - getAllCitapreviaByOpuid', error, 'ERROR')
          })
      }
    },
    borrarCita(event){
      this.$root.$confirm.open('Borrar', '¿Desea borrar la cita?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          let citaAux={
              mscp_id: event.id
          }
          citaApiService.deleteCitaPrevia(citaAux)
            .then(data => {
              util.mostrarEnConsola('citaApiService - deleteCitaPrevia', data.length, 'OK')
            })
            .catch(error => {
              this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
              util.mostrarEnConsola('citaApiService - deleteCitaPrevia', error, 'ERROR')
            })
        } else {
          //volvemos a pintar el evento en el calendarío porque lo borra aun cancelando el borrado
          let horainiAux, horafinAux
          if (event.mscp_horaini) {
            horainiAux = event.mscp_horaini
          } else {
            horainiAux = '09:00'
          }
          if (event.mscp_horafin) {
            horafinAux = event.mscp_horafin
          } else {
            horafinAux = '17:00'
          }
          let eventAux = {
            id: event.mscp_id,
            title: event.mscp_nombre,
            content: event.mscp_telefono,
            email: event.mscp_email,
            start: event.mscp_fecha + ' ' + horainiAux,
            end: event.mscp_fecha + ' ' + horafinAux,
            class: event.mscp_color,
            contentFull: event.mscp_desc
          }
          this.events.push(eventAux)
        }
      })
    },
    /** evento que muestra una ventana modal al clickar un evento */
    onEventClick (event, e) {
      console.log(e)
      this.selectedEvent = event
      // this.showDialog = true
      this.showEventCreationDialog = true
      // this.deleteEventFunction = deleteEventFunction
      e.stopPropagation()
      return event
      // Prevent navigating to narrower view (default vue-cal behavior).
      
    },
    onEventCreate (event, deleteEventFunction) {
      var inicio = this.roundMinutes(new Date(event.start))
      event.start= inicio
      event.end= new Date(inicio.getTime() + 30*60000)
      this.selectedEvent = event
      this.showEventCreationDialog = true
      this.deleteEventFunction = deleteEventFunction

      return event
    },
    cancelEventCreation () {
      this.closeCreationDialog()
      this.deleteEventFunction()
    },
    closeCreationDialog () {
      this.showEventCreationDialog = false
      this.$refs.vuecal.$forceUpdate()
      this.selectedEvent = {}
    },
    roundMinutes(date) {
      date.setHours(date.getHours() + Math.round(date.getMinutes()/60));
      date.setMinutes(0, 0, 0); // Resets also seconds and milliseconds
      return date;
    },
    crearCita() {
      if (this.opuid && this.cita.horaini && this.cita.title !=='' && this.cita.email !=='' ) {
        let fechaAux= this.cita.dia + ' ' + this.cita.horaini
        let citaAux={
          //mscp_id: 0,
          mscp_nombre: this.cita.title,
          mscp_telefono: this.cita.telefono,
          mscp_email: this.cita.email,
          mscp_fecha: this.cita.dia,
          mscp_horaini: moment(this.cita.horaini, "H:mm").format('HH:mm:ss'),
          mscp_horafin:  moment(this.cita.horaini, "hh:mm").add(this.cita.minutos,'minutes').format('HH:mm:ss'),
          mscp_color: this.cita.class,
          mscp_desc: this.cita.desc,
          mscp_opuid: this.opuid
        }
        console.log(citaAux)
        citaApiService.addCitaPrevia(citaAux)
          .then(data => {
            this.$root.$emit('mostrarAlerta', 'Cita creada correctamente', 'info')
            this.$refs.vuecal.createEvent(
              // Formatted start date and time or JavaScript Date object.
              fechaAux,
              // Event duration in minutes (Integer).
              this.cita.minutos,
              // Custom event props (optional).
              { title: this.cita.title, content: this.cita.telefono, class: this.cita.class, contentFull: this.cita.desc, email: this.cita.email, id: data.mscp_id })
          })
          .catch(error => {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            util.mostrarEnConsola('citaApiService - addCitaPrevia', error, 'ERROR')
          })
        this.showEventCreationDialog2 = false  
      } else {
        this.$root.$emit('mostrarAlerta', this.$t('lang.mantenimiento.citaprevia.errorcompletar'), 'error')
      }
    },
    cancelar() {
      this.showEventCreationDialog2 = false
    },
    cambiarFecha(date){
      const offset = date.getTimezoneOffset()
      date = new Date(date.getTime() - (offset*60*1000))
      this.cita.dia=date.toISOString().split('T')[0]
    },
    cambiarHorario(args) {
      this.showEventCreationDialog3 = args[1]
      this.rangoMinutos = args[0].msht_rangohora
      this.cita.minutos = args[0].msht_rangohora
      this.cita.horaini = args[0].msht_aperturaman
      if (args[0].msht_aperturaman) {
        this.horaApertura = args[0].msht_aperturaman.substring(0, 2)
      }
      else {
        this.horaApertura = 9
      }
      if (args[0].msht_cierretar) {
        this.horaCierre = args[0].msht_cierretar.substring(0, 2)
      } else {
        this.horaCierre = 22
      }
      console.log(args[0])
    },
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getOpuid;
    }, 
    cliente () {
      return this.$store.getters.getCliente
    }
  }
}
</script>
